/**
 * @notice MUST BE USE `process.env`.
 * Dead Code Elimination - for tree shaking
 *
 * @desc env
 *  - NODE_ENV
 *  - NEXT_PUBLIC_ENV
 *  - NEXT_PUBLIC_SITE_NAME
 *  - ${NextBuildPhase}
 */

/** NODE_ENV */
export const IS_NODE_TEST = process.env.NODE_ENV === 'test';
export const IS_NODE_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_NODE_PRODUCTION = process.env.NODE_ENV === 'production';

/** NEXT_PUBLIC_ENV */
export const IS_APP_DEV = process.env.NEXT_PUBLIC_ENV === 'dev';
export const IS_APP_LOCAL = process.env.NEXT_PUBLIC_ENV === 'local';
export const IS_APP_TEST = process.env.NEXT_PUBLIC_ENV === 'test';
export const IS_APP_TEST2 = process.env.NEXT_PUBLIC_ENV === 'test2';
export const IS_APP_UAT = process.env.NEXT_PUBLIC_ENV === 'uat';
export const IS_APP_PRODUCTION = process.env.NEXT_PUBLIC_ENV === 'production';
export const IS_LOCAL_RUNTIME = IS_NODE_DEVELOPMENT || IS_APP_LOCAL;

/** NEXT_PUBLIC_SITE_NAME */
export const IS_DE = process.env.NEXT_PUBLIC_SITE_NAME === 'de';
export const IS_FR = process.env.NEXT_PUBLIC_SITE_NAME === 'fr';
export const IS_UK = process.env.NEXT_PUBLIC_SITE_NAME === 'uk';
export const IS_CA = process.env.NEXT_PUBLIC_SITE_NAME === 'ca';
export const IS_US = process.env.NEXT_PUBLIC_SITE_NAME === 'us';
export const IS_DE_FR = IS_DE || IS_FR;

/** ${NextBuildPhase} */
export const IS_NEXT_BUILD_PHASE =
  process.env.NEXT_PHASE === 'phase-production-build' || process.env.__NEXT_COMPILER === 'true';
